const features = [
  { title: '完全免费', desc: '无需注册登录，无需付费会员，打开即看，没有任何隐藏收费。', icon: 'ri-money-cny-circle-line', color: 'primary' },
  { title: '高清画质', desc: '支持720P/1080P高清播放，画面清晰细腻，带来沉浸式观影体验。', icon: 'ri-4k-line', color: 'accent' },
  { title: '极速加载', desc: '智能CDN加速 + 多线服务器，视频秒加载，播放流畅不缓冲。', icon: 'ri-speed-up-line', color: 'primary' },
  { title: '海量片库', desc: '超过30万部影视资源，每日更新，热播剧集与院线大片一网打尽。', icon: 'ri-database-2-line', color: 'accent' },
  { title: '全端兼容', desc: '手机、平板、电脑均可播放，适配所有主流浏览器，无需安装App。', icon: 'ri-device-line', color: 'primary' },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-3">为什么选择番茄影视</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            五大核心优势，让每一次观影都成为享受
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {features.map((feat, i) => (
            <div
              key={i}
              className="rounded-2xl p-6 md:p-7 bg-background-100 border border-background-200/70 hover:border-primary-100 transition-all duration-300 cursor-pointer text-center group"
            >
              <div className={`w-14 h-14 mx-auto mb-4 rounded-2xl flex items-center justify-center ${
                feat.color === 'primary' ? 'bg-primary-100 group-hover:bg-primary-200' : 'bg-accent-100 group-hover:bg-accent-200'
              } transition-colors`}>
                <i className={`${feat.icon} text-2xl ${
                  feat.color === 'primary' ? 'text-primary-600' : 'text-accent-600'
                }`}></i>
              </div>
              <h3 className="font-heading font-semibold text-base text-foreground-900 mb-2">{feat.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}